<template>
  <Teleport to="body">
    <ModalFade>
      <div v-if="shown" class="fixed left-0 top-0 z-dialog size-full">
        <div
          class="grid size-full place-items-center bg-black/40"
          @click.self="onClickOutside"
        >
          <div
            v-testid="'ダイアログ'"
            class="modal-container flex w-[360px] flex-col items-end justify-center rounded-lg bg-white transition-transform duration-200 ease-in-out"
          >
            <div class="w-full border-b border-border px-6 pb-10 pt-4">
              <div class="text-base-b">{{ title }}</div>
              <div class="mt-3 whitespace-pre-wrap">{{ text }}</div>
            </div>

            <ul class="flex gap-x-2 px-6 py-4">
              <li>
                <NewBaseButton
                  v-if="onCancel"
                  size="sm"
                  class="min-w-24"
                  :theme="cancelButtonColor"
                  @click="onCancel"
                  >{{ cancelText }}</NewBaseButton
                >
              </li>
              <li>
                <NewBaseButton
                  v-if="onAccept"
                  size="sm"
                  class="min-w-24"
                  :theme="acceptButtonColor"
                  @click="onAccept"
                  >{{ acceptText }}</NewBaseButton
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ModalFade>
  </Teleport>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    shown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    acceptText: {
      type: String,
      default: 'OK',
    },
    acceptButtonColor: {
      type: String,
      default: 'primary',
    },
    cancelText: {
      type: String,
      default: 'キャンセル',
    },
    cancelButtonColor: {
      type: String,
      default: 'secondary',
    },
    onAccept: {
      type: Function,
      default: undefined,
    },
    onCancel: {
      type: Function,
      default: undefined,
    },
    onClose: {
      type: Function,
      default: undefined,
    },
    canCloseOutsideClick: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClickOutside() {
      if (this.canCloseOutsideClick && this.onClose) {
        this.onClose()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  display: flex;
  width: 360px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background-color: #fff;
  border-radius: 8px;
  // transition: transform 0.25s ease-in-out;
}
</style>
